/**
 * TEMP-DIAG — collapsible diagnostics panel shown on the Driver login screen
 * when the journal has entries (native builds only, since logDiag no-ops on
 * web). REMOVE before release together with src/debug/diagJournal.js.
 */
import { useState } from "react";
import { readDiag, clearDiag } from "./diagJournal";

export default function DriverDiagnosticsPanel() {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState(readDiag);
  if (!entries.length) return null;
  return (
    <div className="mt-4 text-left" data-testid="driver-diagnostics-panel">
      <button
        type="button"
        onClick={() => { setEntries(readDiag()); setOpen((o) => !o); }}
        className="w-full text-xs font-mono text-amber-300 bg-slate-800 border border-amber-500/40 rounded-md px-3 py-2"
        data-testid="driver-diagnostics-toggle"
      >
        DIAG journal ({entries.length}) — tap to {open ? "hide" : "show"}
      </button>
      {open && (
        <div className="mt-2 bg-slate-950 border border-slate-700 rounded-md p-2 max-h-72 overflow-y-auto">
          {entries.map((e, i) => (
            <pre
              key={i}
              className="text-[10px] leading-tight text-slate-300 whitespace-pre-wrap break-all border-b border-slate-800 py-1"
            >
              {JSON.stringify(e)}
            </pre>
          ))}
          <button
            type="button"
            onClick={() => { clearDiag(); setEntries([]); setOpen(false); }}
            className="mt-2 text-[10px] text-red-400 underline"
            data-testid="driver-diagnostics-clear"
          >
            Clear journal
          </button>
        </div>
      )}
    </div>
  );
}
